import React, {
  FC,
  useEffect,
  useState,
} from 'react';
import styled, { StyledComponent } from 'styled-components';
import truncate from 'truncate-html';

import { useIsDesktop } from '@/utils/hooks/useIsDesktop';

interface ShowMoreTextProps {
  html: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
  htmlWrapper: StyledComponent<'div', any, {}, never>;
  maxLength?: number;
}

export const RestText = styled.span<{ $showMore: boolean }>`
  display: ${({ $showMore }) => ($showMore ? 'inline' : 'none')};
`;

export const ButtonWrapper = styled.div<{ $showMore: boolean }>`
  display: flex;
  justify-content: center;
  margin: 8px 0 14px;

  button {
    overflow: visible;
    width: auto;
    margin: 0 0 3px;
    border: none;
    padding: 4px;
    background-color: inherit;
    color: #595959;
    cursor: pointer;

    span {
      display: inline-block;
      margin: 0 0 ${({ $showMore }) => ($showMore ? '0' : '3px')} 5px;
      border: solid black;
      border-width: 0 1px 1px 0;
      padding: 2px;
      transform: rotate(${({ $showMore }) => ($showMore ? '-135deg' : '45deg')});
    }
  }
`;

export const ShowMoreHtml: FC<ShowMoreTextProps> = ({
  html,
  htmlWrapper: HtmlWrapper,
  maxLength = 100,
}) => {
  const [
    showMore,
    setShowMore,
  ] = useState<boolean>(false);
  const [
    isDesktop,
    setIsDesktop,
  ] = useState<boolean>(false);
  const isDesktopFromHook = useIsDesktop();

  useEffect(() => {
    setIsDesktop(isDesktopFromHook);
  }, [isDesktopFromHook]);

  return (
    <>
      {isDesktop || html.length <= maxLength + 3 ?
        (
          <HtmlWrapper
            dangerouslySetInnerHTML={{
              __html: html,
            }}
          />
        ) :
        (
          <>
            <HtmlWrapper
              dangerouslySetInnerHTML={{
                __html: showMore ? html : truncate(html, maxLength),
              }}
            />
            <ButtonWrapper $showMore={showMore}>
              <button
                type="button"
                aria-expanded={showMore}
                aria-controls="more-content"
                onClick={() => setShowMore(!showMore)}
              >
                {!showMore ? 'Read more' : 'Hide description'}
                <span />
              </button>
            </ButtonWrapper>
          </>
        )}
    </>
  );
};
